import {usePlant} from './usePlant'

export function usePlantId(): string {
  const plant = usePlant()
  return plant?.id ?? ''
}
